import React from 'react';
import { Typography } from '@pw-tech/omni-ui';
import Image from 'next/image';
import { InfoIcon } from 'lucide-react';
const Waiting = () => {
  return <article data-sentry-component="Waiting" data-sentry-source-file="Waiting.tsx">
      <Typography variant="heading3" weight="semi-bold" data-sentry-element="Typography" data-sentry-source-file="Waiting.tsx">
        Interview
      </Typography>
      <div className="p-5 border-2 border-[#A7F3D0] bg-[#F0FFF6] rounded-lg flex flex-col gap-3 mt-6">
        <div className="flex flex-col items-center gap-1 text-center">
          <Image src="https://static.pw.live/5eb393ee95fab7468a79d189/ADMIN/f526c671-e13a-40bc-b21e-4c493a54c23c.svg" alt="waiting" width={40} height={40} data-sentry-element="Image" data-sentry-source-file="Waiting.tsx" />
          <Typography variant="heading3" weight="semi-bold" className="!text-[#14532D]" data-sentry-element="Typography" data-sentry-source-file="Waiting.tsx">
            Congratulations!
            <br />
            You&rsquo;re a Top Performer
          </Typography>
        </div>
        <Typography variant="regular" className="!text-sm !text-[#3D3D3D]" data-sentry-element="Typography" data-sentry-source-file="Waiting.tsx">
          Because of your outstanding results, you&apos;ve qualified for a{' '}
          <span className="font-bold">personal interview for an additional scholarship!</span>
        </Typography>
        <ul className="list-disc pl-5 flex flex-col gap-1">
          <li>
            <Typography variant="regular" className="!text-sm !text-[#3D3D3D]" data-sentry-element="Typography" data-sentry-source-file="Waiting.tsx">
              <span className="font-bold">Next Steps:</span> Our team will contact you within{' '}
              <span className="font-bold">5–7 days</span> to schedule your session.
            </Typography>
          </li>
          <li>
            <Typography variant="regular" className="!text-sm !text-[#3D3D3D]" data-sentry-element="Typography" data-sentry-source-file="Waiting.tsx">
              <span className="font-bold">Note:</span> This interview is non-eliminatory and serves
              only to increase your potential award.
            </Typography>
          </li>
        </ul>
      </div>

      <div className="flex items-start gap-2 mt-2">
        <div className="flex-shrink-0 flex items-center justify-center mt-0.5">
          <InfoIcon size={20} color="#000000" data-sentry-element="InfoIcon" data-sentry-source-file="Waiting.tsx" />
        </div>
        <Typography variant="regular" className="!text-sm !text-[#3D3D3D]" data-sentry-element="Typography" data-sentry-source-file="Waiting.tsx">
          Please keep an eye on your email for your{' '}
          <span className="font-bold">official invitation</span> and further instructions.
        </Typography>
      </div>
    </article>;
};
export default Waiting;